export function isLocalhost(): boolean {
  return window.location && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
}
